module.exports = __webpack_public_path__ + "img/title.f47ed394.png";